import { FilterGroup, IsFilterDisabled } from "./types";
import { i18n } from "@/i18n";
import { PartnerFeatureEnum } from "@/__generated__/types";
const { t } = i18n;

const disabledForRise: IsFilterDisabled = ({ featureFlags }) => {
  return !!featureFlags?.includes(PartnerFeatureEnum.RisePredictiveModels);
};

const disabledForNonRise: IsFilterDisabled = ({ featureFlags }) => {
  return !featureFlags?.includes(PartnerFeatureEnum.RisePredictiveModels);
};

export const filterGroups: FilterGroup[] = [
  {
    title: t("filters.topFilters"),
    filters: [
      {
        label: t("filters.cohortYear"),
        name: "cohortYear",
        type: "DropdownMultiSelect",
        disableSearch: true,
        placeholder: t("filters.selectCohortYear"),
        options: [],
      },
      {
        label: t("filters.studentType"),
        name: "studentType",
        type: "Radio",
        options: [],
      },
      {
        label: t("filters.funnelState"),
        name: "funnelStates",
        type: "Checkboxes",
        options: [],
      },
      {
        label: t("filters.assignedCounselors"),
        placeholder: t("filters.selectCounselors"),
        name: "assignedCounselors",
        type: "DropdownMultiSelect",
        options: [],
      },
      {
        label: t("filters.commitIndex"),
        name: "commitIndex",
        type: "Checkboxes",
        options: [],
        isDisabled: disabledForRise,
      },
      {
        label: t("filters.mostEngaged"),
        placeholder: t("filters.selectMostEngaged"),
        name: "engagementPercentile",
        type: "Radio",
        options: [],
      },
      // {
      //   label: t("filters.commitScoreTrends"),
      //   name: "commitScoreTrend",
      //   type: "Radio",
      //   options: [],
      //   isDisabled: disabledForRise,
      // },
    ],
  },
  {
    title: t("filters.appData"),
    filters: [
      {
        label: t("filters.interests"),
        name: "interests",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectInterests"),
        options: [],
      },
      {
        label: t("filters.major"),
        name: "majors",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectMajor"),
        options: [],
      },
      {
        label: t("filters.goingStatus"),
        name: "goingStatus",
        type: "Checkboxes",
        options: [],
      },
      {
        label: t("filters.goingElsewhere"),
        name: "goingElsewhere",
        type: "Radio",
      },
      {
        label: t("filters.moreActiveElsewhere"),
        name: "moreActiveElsewhere",
        type: "Radio",
        filterDisplayType: "RISE",
        isDisabled: disabledForNonRise,
      },
      {
        label: t("filters.attendedALiveEvent"),
        name: "attendedALiveEvent",
        type: "Radio",
      },
      {
        label: t("filters.joinDate"),
        name: "joinDate",
        type: "DateRange",
      },
      {
        label: t("filters.joinType"),
        name: "joinType",
        type: "Checkboxes",
        options: [],
      },
      {
        label: t("filters.joinState"),
        name: "joinState",
        type: "Checkboxes",
        options: [],
      },
    ],
  },
  {
    title: t("filters.predictiveModels"),
    filters: [
      {
        label: t("filters.applyIndex"),
        name: "applyIndex",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectApplyIndex"),
        options: [],
        filterDisplayType: "RISE",
        isDisabled: disabledForNonRise,
      },
      {
        label: t("filters.riseCommitIndex"),
        name: "riseCommitIndex",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectRiseCommitIndex"),
        options: [],
        filterDisplayType: "RISE",
        isDisabled: disabledForNonRise,
      },
      {
        label: t("filters.meltIndex"),
        name: "meltIndex",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectMeltIndex"),
        options: [],
        filterDisplayType: "RISE",
        isDisabled: disabledForNonRise,
      },
      {
        label: t("filters.yieldIndex"),
        name: "yieldIndex",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectYieldIndex"),
        options: [],
        filterDisplayType: "RISE",
        isDisabled: disabledForNonRise,
      },
      // {
      //   label: t("filters.upTrending"),
      //   name: "upTrendingScores",
      //   type: "DropdownMultiSelect",
      //   placeholder: t("filters.selectModel"),
      //   options: [],
      //   filterDisplayType: "RISE",
      //   isDisabled: disabledForNonRise,
      // },
      // {
      //   label: t("filters.downTrending"),
      //   name: "downTrendingScores",
      //   type: "DropdownMultiSelect",
      //   placeholder: t("filters.selectModel"),
      //   options: [],
      //   filterDisplayType: "RISE",
      //   isDisabled: disabledForNonRise,
      // },
    ],
  },
  {
    title: t("filters.studentDetails"),
    filters: [
      {
        label: t("filters.gender"),
        name: "gender",
        type: "Checkboxes",
        options: [],
      },
    ],
  },
  {
    title: t("filters.locationSection"),
    filters: [
      {
        label: t("filters.country"),
        name: "country",
        type: "Radio",
        options: [],
      },
      {
        label: t("filters.state"),
        name: "state",
        type: "DropdownMultiSelect",
        placeholder: t("filters.selectState"),
        options: [],
      },
      {
        label: t("filters.zipCode"),
        name: "zipCode",
        type: "TokenizedTextInput",
        placeholder: t("filters.selectZipCode"),
        tokenIsValid: (str) => /^[0-9]{5}(-[0-9]{4})?$/.test(str),
      },
    ],
  },
  {
    title: t("filters.crmAndApplicationData"),
    filters: [
      // TODO: re-enable when fixed on data side
      // {
      //   label: t("filters.directAdmission"),
      //   name: "directAdmission",
      //   type: "Radio",
      // },
      {
        label: t("filters.firstGeneration"),
        name: "firstGeneration",
        type: "Radio",
      },
      // TODO: re-enable when fixed on data side
      // {
      //   label: t("filters.studentAthlete"),
      //   name: "studentAthlete",
      //   type: "Radio",
      // },
      {
        label: t("filters.campusVisit"),
        name: "campusVisit",
        type: "Radio",
      },
      {
        label: t("filters.commitDate"),
        name: "commitDate",
        type: "DateRange",
      },
      // {
      //   label: t("filters.leadSource"),
      //   name: "leadSource",
      //   type: "DropdownMultiSelect",
      //   disableSearch: true,
      //   placeholder: t("filters.selectLeadSource"),
      //   options: [
      //     { label: "Lead Source 1", value: "Lead Source 1" },
      //     { label: "Lead Source 2", value: "Lead Source 2" },
      //     { label: "Lead Source 3", value: "Lead Source 3" },
      //     { label: "Lead Source 4", value: "Lead Source 4" },
      //   ],
      // },
      {
        label: t("filters.entryTerm"),
        name: "entryTerm",
        type: "DropdownMultiSelect",
        disableSearch: true,
        placeholder: t("filters.selectEntryTerm"),
        options: [],
      },
      {
        label: t("filters.fafsaCompletionStatus"),
        name: "fafsaCompletionStatus",
        type: "Radio",
      },
      {
        label: t("filters.ceebCode"),
        name: "ceebCode",
        type: "TokenizedTextInput",
        placeholder: t("filters.selectCeebCode"),
        tokenIsValid: (val: string) => {
          return /^\d{5}$/.test(val);
        },
      },
    ],
  },
];
